import React, { lazy, Suspense } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { StickyCTA } from './components/ui/StickyCTA';

// Everything below the hero is code-split into its own chunk and loaded right
// after the initial paint — none of it is needed to render the first screen,
// so it shouldn't compete with the hero/LCP for the browser's main thread.
const TrustStats = lazy(() => import('./components/sections/TrustStats').then(mod => ({
  default: mod.TrustStats
})));
const Transformation = lazy(() => import('./components/sections/Transformation').then(mod => ({
  default: mod.Transformation
})));
const Method = lazy(() => import('./components/sections/Method').then(mod => ({
  default: mod.Method
})));
const ForYou = lazy(() => import('./components/sections/ForYou').then(mod => ({
  default: mod.ForYou
})));
const WhatYouGet = lazy(() => import('./components/sections/WhatYouGet').then(mod => ({
  default: mod.WhatYouGet
})));
const InstantAccess = lazy(() => import('./components/sections/InstantAccess').then(mod => ({
  default: mod.InstantAccess
})));
const BonusesDetail = lazy(() => import('./components/sections/BonusesDetail').then(mod => ({
  default: mod.BonusesDetail
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const AboutAuthor = lazy(() => import('./components/sections/AboutAuthor').then(mod => ({
  default: mod.AboutAuthor
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(mod => ({
  default: mod.Pricing
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="3udazyhcy738x">
      <div className="w-full min-h-full bg-white font-body text-gris-oscuro" data-id="element-1" data-mp="3ucjcxuxf2du9">
        <main data-id="element-2" data-mp="d3cuxpqygsfi">
          <Hero data-id="element-3" data-mp="d45v27vesjoo" />
          <Suspense fallback={null} data-id="element-4" data-mp="d2l6qzzotwz9">
            <TrustStats data-id="element-5" data-mp="851n1kk80rzx" />
            <Transformation data-id="element-6" data-mp="86w58r43y60b" />
            <Method data-id="element-7" data-mp="83i23gnmdsrt" />
            <ForYou data-id="element-8" data-mp="3gleaym6kt9gr" />
            <WhatYouGet data-id="element-9" data-mp="3gkla21uate6j" />
            <InstantAccess data-id="element-10" data-mp="3gm61hilbgh06" />
            <BonusesDetail data-id="element-11" data-mp="3gja35t5k3qb7" />
            <Testimonials data-id="element-12" data-mp="3bmjo995hn0rd" />
            <AboutAuthor data-id="element-13" data-mp="3bncp5thrmw1l" />
            <Pricing data-id="element-14" data-mp="3bo4kd37garrc" />
            <Guarantee data-id="element-15" data-mp="3bkgtycxaylgu" />
            <FAQ data-id="element-16" data-mp="3qbppf2nvz11w" />
            <FinalCTA data-id="element-17" data-mp="3qc95edtz7fda" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-18" data-mp="3lkhg06mk3foq">
          <Footer data-id="element-19" data-mp="3ljg2zwlzcj4d" />
        </Suspense>
        <StickyCTA data-id="element-20" data-mp="3lieeapc1jy46" />
      </div>
    </LazyMotion>;
}